<ng-container *ngFor="let row of leftWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g
            [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <path      class="window-left"
            [style.animationDelay]="i * j * 0.01 + 's'"
                d="M6 16 L0 12 L0 28 L0 30.5 L6 35 Z"
                fill="var(--window-lit-bg-1)" />
        </svg:g>
    </ng-container>
</ng-container>

<ng-container *ngFor="let row of rightWindowPositions(); let i = index; trackBy: trackByIndex">
    <ng-container *ngFor="let position of row; let j = index">
        <svg:g
            [attr.transform]="'translate(' + position.x + ', ' + position.y + ')'">
            <path      class="window-right"
            [style.animationDelay]="i * j * 0.01 + 's'"
                d="M6 10 L0 13 L0 28 L0 30.5 L6 27 Z"
                fill="var(--window-lit-bg-2)" />
        </svg:g>
    </ng-container>
</ng-container>
